module.exports = __webpack_public_path__ + "static/media/logo-tomathien.89156e1c.png";